module.exports = __webpack_public_path__ + "static/media/phone.8a22b684.svg";